import React from "react";
import LeftMenuWindow from "./UserMenuLeftBar";
import AccountSettings from "./AccountSettings";
import { Grid, PlatformPageDialog } from "@platform/style";
import useOneAdmin from "./hooks/useOneAdmin";
import { BackendFailureAlert } from "@platform/core";

interface UserMenuProps {
  open: boolean;
  handleClose: () => void;
  preferencesId: string;
}

export default function UserMenu(props: UserMenuProps) {
  const [linkToOneAdminError, setLinkToOneAdminError] = React.useState<Error>();

  const { isAdmin, linkToOneAdmin, correlationId } = useOneAdmin();
  return (
    <PlatformPageDialog
      title={"Account Settings"}
      eventName={"AccountSettings"}
      showPageHeader={false}
      showCloseIcon={true}
    >
      {/*Failure alert to let the user know that an attempt to link to One Admin failed*/}
      {linkToOneAdminError && (
        <div style={{ paddingTop: "24px" }}>
          <BackendFailureAlert
            failures={[
              {
                message:
                  "Unable to link to One Admin. Try again. If the error persists, click the button to report to Client Support.",
                component: "AppHeader",
                exceptionInformation: linkToOneAdminError.stack?.toString().replace(/[\n\r]/g, ""),
                correlationId: correlationId,
              },
            ]}
          />
        </div>
      )}
      <Grid container spacing={9} wrap="nowrap">
        <Grid item style={{ width: "320px" }}>
          <LeftMenuWindow
            handleClose={() => props.handleClose()}
            isAdmin={isAdmin}
            linkToOneAdmin={linkToOneAdmin}
            setLinkToOneAdminError={setLinkToOneAdminError}
          />
        </Grid>
        <Grid item>
          {props.preferencesId && <AccountSettings preferencesId={props.preferencesId} />}
        </Grid>
      </Grid>
    </PlatformPageDialog>
  );
}
